import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_approval_delegation_period_RowClass} from '../../../dbschema';

export class ClaimApprovalDelegationPeriodContainerModel extends BaseContainerModel {
  bl_aat_claim_approval_delegation_period: bl_aat_claim_approval_delegation_period_RowClass = new bl_aat_claim_approval_delegation_period_RowClass();
}
